import { useMemo } from 'react';
import { CustomerPortalWidget } from 'api/customer-portal/types';

const getBackground = (widget: CustomerPortalWidget) => {
  const bg = widget?.widgetDefinition?.styles?.background;

  if (!bg) {
    return '#FFFFFF';
  }

  return bg as string;
};

export const useGetBackground = (widget: CustomerPortalWidget) => {
  const background = useMemo(() => getBackground(widget), [widget]);

  return background;
};

export const useGetBackgroundSafe = (
  widget: CustomerPortalWidget | undefined,
) => {
  const background = useMemo(
    () => (widget ? getBackground(widget) : '#000'),
    [widget],
  );

  return background;
};

export const useGetStyle = <T>(
  widget: CustomerPortalWidget,
  key: string,
  defaultValue?: T,
) => {
  const style = useMemo(() => {
    const styles = widget?.widgetDefinition?.styles;

    if (!styles) {
      return defaultValue;
    }

    return (styles[key] ?? defaultValue) as T;
  }, [defaultValue, key, widget?.widgetDefinition?.styles]);

  return style;
};
